module.exports = __webpack_public_path__ + "static/media/cover_abi_mathe_analysis.7fab7c7d.jpg";